<div *ngIf="layout.isLoading" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<app-vertical-layout *ngIf="layout.orientation === 'vertical'">
    <router-outlet/>
</app-vertical-layout>

<app-horizontal-layout *ngIf="layout.orientation === 'horizontal'">
    <router-outlet/>
</app-horizontal-layout>
